export default "__VITE_ASSET__eooNctNr__"